module.exports = __webpack_public_path__ + "img/8.2ef6e380.jpg";